(function () {
  const UPC_LINE_PATTERN = /^\s*(?:UPC\s*:?\s*)?\d{10,14}\s*$/i;
  const TRAILING_UPC_LINE_PATTERN = /(?:^|[\r\n])\s*(?:UPC\s*:?\s*)?\d{10,14}\s*$/i;
  const MEDIA_SELECTOR = 'img, video, iframe, object, embed, table, ul, ol';

  function cleanText(text) {
    return String(text || '').replace(/\u00a0/g, ' ');
  }

  function isUpcOnly(text) {
    return UPC_LINE_PATTERN.test(cleanText(text));
  }

  function stripTrailingUpcLine(text) {
    const clean = cleanText(text);
    const match = clean.match(TRAILING_UPC_LINE_PATTERN);
    if (!match) return null;

    return text.slice(0, match.index).replace(/[ \t\u00a0]+$/g, '');
  }

  function isSafeTextElement(element) {
    return !element.querySelector(MEDIA_SELECTOR);
  }

  function isEmptyElement(element) {
    if (element.querySelector(MEDIA_SELECTOR)) return false;
    return !cleanText(element.textContent).trim();
  }

  function trimTrailingBlankNodes(root) {
    while (root.lastChild) {
      const node = root.lastChild;

      if (node.nodeType === Node.COMMENT_NODE) {
        node.remove();
        continue;
      }

      if (node.nodeType === Node.TEXT_NODE && !cleanText(node.textContent).trim()) {
        node.remove();
        continue;
      }

      if (node.nodeType === Node.ELEMENT_NODE && isEmptyElement(node)) {
        node.remove();
        continue;
      }

      break;
    }
  }

  function stripTrailingUpc(root) {
    let changed = false;

    while (root.lastChild) {
      trimTrailingBlankNodes(root);
      const node = root.lastChild;
      if (!node) break;

      if (node.nodeType === Node.TEXT_NODE) {
        if (isUpcOnly(node.textContent)) {
          node.remove();
          changed = true;
          continue;
        }

        const stripped = stripTrailingUpcLine(node.textContent);
        if (stripped !== null) {
          node.textContent = stripped;
          changed = true;
          continue;
        }
      }

      if (node.nodeType === Node.ELEMENT_NODE && isSafeTextElement(node)) {
        if (isUpcOnly(node.textContent)) {
          node.remove();
          changed = true;
          continue;
        }

        if (stripTrailingUpc(node)) {
          if (isEmptyElement(node)) node.remove();
          changed = true;
          continue;
        }
      }

      break;
    }

    trimTrailingBlankNodes(root);
    return changed;
  }

  function init(root) {
    root.querySelectorAll('.product__description.rte').forEach(stripTrailingUpc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
